export default "__VITE_ASSET__DBOtnapC__"